import { createRouter, createWebHistory } from "vue-router";
import routes from '@/router/routes.js'
import { useAuth } from "../stores/auth";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    else if (to.hash) {
      const headerEl = document.querySelector('header');
      const topOffset = headerEl ? headerEl.clientHeight : 0;
      if (from.name !== 'home') {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              el: to.hash,
              behavior: 'smooth',
              top: topOffset
            })
          }, 500)
        });
      }
      else {
        return {
          el: to.hash,
          behavior: 'smooth',
          top: topOffset

        }
      }
      }
    else {
      return { top: 0 };
    }
  }
});

// navigation guards
router.beforeEach(async (to, from, next) => {

  const auth = useAuth();

  /*
    if (!auth.user) {
      try {
        await auth.loadUser();
      } catch (e) {
        // No action, just catch it
      }
    }
  */

  if (to.meta.requiresAuth && !auth.user) {
    try {
      await auth.loadUser();
    } catch (e) {
      // No action, just catch it
    }
    if (!auth.user) {
      // redirect the user to the login page
      auth.showAuthModal();
      // TODO if user is shown auth modal because he needs to login, after login need to return to the rout he was intending to go.
      return next({ name: "home" });
    }
  }

  return next();
});

export default router;
